// Theme switch (light / auto / dark) in the footer. The stored theme is applied before the first paint by `partials/theme-init.hbs`.

import {writeStorage} from '../lib/storage.ts'

/** Local storage key of the chosen theme. Must match the key in `partials/theme-init.hbs`. */
const THEME_KEY = 'theme'

const options = document.querySelectorAll<HTMLElement>('.themeSwitchOption')

export function initThemeSwitch() {
    options.forEach(option => option.addEventListener('click', () => setTheme(option.dataset.themeOption ?? 'auto')))
    updateOptions()
}

/** Applies and persists the theme: 'light', 'dark' or 'auto' to follow the system */
function setTheme(theme: string) {
    const isAuto = theme === 'auto'
    if (isAuto) delete document.documentElement.dataset.theme
    else document.documentElement.dataset.theme = theme
    writeStorage(THEME_KEY, isAuto ? null : theme)
    updateOptions()
}

function updateOptions() {
    const theme = document.documentElement.dataset.theme ?? 'auto'
    options.forEach(option => option.setAttribute('aria-pressed', String(option.dataset.themeOption === theme)))
}
